import {
  getBootstrapWorkspaceRefs,
  getGtmWorkspaceRefs,
} from './bootstrap-workspaces'
import type { BootstrapData } from '@/features/bootstrap/types/bootstrap'
import { GTM_PRODUCT_SCOPE } from '@/shared/lib/gtm-product-scope'

export function hasBootstrapWorkspaces(bootstrap: BootstrapData): boolean {
  const workspaces = GTM_PRODUCT_SCOPE.legacyWorkspaceUi
    ? getBootstrapWorkspaceRefs(bootstrap.workspaces)
    : getGtmWorkspaceRefs(bootstrap.workspaces)
  return workspaces.length > 0
}

export function shouldRedirectToNoWorkspaceEntry(
  bootstrap: BootstrapData,
): boolean {
  return !hasBootstrapWorkspaces(bootstrap)
}

export function getNoWorkspacesEntryRoute(
  _bootstrap: BootstrapData,
): '/$lang' | '/$lang/workspace' {
  // GTM: a workspace is provisioned from a demo analysis, so an account
  // without one starts a GTM analysis instead of team onboarding.
  if (!GTM_PRODUCT_SCOPE.legacyWorkspaceUi) {
    return '/$lang'
  }

  // No plans or trial onboarding (pay-as-you-go, LP-272): an account without
  // workspace access sees the workspace list.
  return '/$lang/workspace'
}
